export default __webpack_public_path__ + "static/media/icongmage.00fcc340.png";